/**
 * Generate an object that contains all of the data properties being tracked by the SimpleObject
 * @return {object}
 */
function ObjectExport(obj: any, ignoreProps: string[] = []): object | any[]
{
    const output = Array.isArray(obj) ? [] : {};

    Object.keys(obj).forEach((key) =>
    {
        if (ignoreProps.indexOf(key) === -1)
        {
            if (obj[key] instanceof Function === false)
            {
                if (obj[key] instanceof Object)
                {
                    output[key] = ObjectExport(obj[key], ignoreProps);
                }
                else
                {
                    output[key] = obj[key];
                }
            }
        }
    });

    return output;
}

export default ObjectExport;